import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AnonGuard} from './shared/guards/anon.guard';
import {AuthGuard} from './shared/guards/auth.guard';
import {LogoutComponent} from './shared/components/logout/logout.component';
import {RouteUrls} from './shared/constants/RouteUrls';
import {RedirectComponent} from './shared/components/redirect.component';
import {NoPermissionComponent} from './shared/components/no-permission/no-permission.component';
import {PaymentCheckoutComponent} from './modules/financial/payment-checkout/payment-checkout.component';
import {PublicInvoiceViewComponent} from './modules/financial/public-invoice-view/public-invoice-view.component';
import {NotLoggedLayoutComponent} from './modules/layout/not-logged-layout/not-logged-layout.component';
import {LoggedLayoutComponent} from './modules/layout/logged-layout/logged-layout.component';
import {PermissionPathComponent} from './modules/permission-path/permission-path.component';
import {QuickbooksAuthenticationComponent} from './modules/financial/quickbooks-authentiation/quickbooks-authentication.component';
import { PaymentSuccessViewComponent } from './modules/financial/payment-checkout/payment-success-view/payment-success-view.component';

const routes: Routes = [
  {
    path: '',
    component: LoggedLayoutComponent,
    children: [
      {
        path: '',
        component: PermissionPathComponent,
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.DASHBOARD.MODULE_BASE,
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
      },
      {
        path: '',
        loadChildren: () => import('./modules/account-settings/account-settings.module').then(it => it.AccountSettingsModule),
        canActivate: [AuthGuard]
      },
      {
        path: '',
        loadChildren: () => import('./modules/financial/financial.module').then(it => it.FinancialModule),
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.APPLICATION.MODULE_BASE,
        loadChildren: () => import('./modules/application-list/application-list.module').then(it => it.ApplicationListModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'facility',
        loadChildren: () => import('./modules/facility-list/facility-list.module').then(it => it.FacilityListModule),
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.FACILITY_INFO.MODULE_BASE,
        loadChildren: () => import('./modules/facility-list/facility-information/facility-information.module').then(it => it.FacilityInformationModule),
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.INVESTIGATION.MODULE_BASE,
        loadChildren: () => import('./modules/investigation/investigation.module').then(it => it.InvestigationModule),
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.ACCREDITATION.MODULE_BASE,
        loadChildren: () => import('./modules/accreditation/accreditation.module').then(it => it.AccreditationModule),
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.HISTORY.MODULE_BASE,
        loadChildren: () => import('./modules/history/history.module').then(it => it.HistoryModule),
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.NOTIFICATION.LIST,
        loadChildren: () => import('./modules/notifications/notifications.module').then(it => it.NotificationsModule),
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.FINANCIAL.PAYMENT.CHECKOUT,
        component: PaymentCheckoutComponent,
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.FINANCIAL.PAYMENT.PAYMENT_CHECKOUT,
        component: PaymentCheckoutComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'show_invoice/:hash',
        component: PublicInvoiceViewComponent
      },
      {
        path: 'finance/quickbooks',
        component: QuickbooksAuthenticationComponent
      },
      {
        path: RouteUrls.SURVEY.MODULE_BASE,
        loadChildren: () => import('./modules/survey/survey.module').then(it => it.SurveyModule),
        canActivate: [AuthGuard]
      },
      {
        path: RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT,
        loadChildren: () => import('./modules/external-reports/external-reports.module').then(it => it.ExternalReportsModule),
        canActivate: [AuthGuard]
      },
    ]
  },
  {
    component: NotLoggedLayoutComponent,
    path: '',
    loadChildren: () => import('./modules/authentication/authentication.module').then(it => it.AuthenticationModule),
    canActivate: [AnonGuard]
  },
  {
    path: RouteUrls.LOGOUT,
    component: LogoutComponent
  },
  {
    path: RouteUrls.REDIRECT,
    component: RedirectComponent,
  },
  {
    path: RouteUrls.NO_PERMISSION,
    component: NoPermissionComponent
  },
  {
    path: 'payment-success',
    component: PaymentSuccessViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
